export const sourceOptions = [
  { label: 'Generated', value: 'GENERATED' },
  { label: 'Uploaded', value: 'UPLOADED' },
];

export const categoryOptions = [
  { label: 'Risk Assessment', value: 'RISK_ASSESSMENT' },
  { label: 'Annex IV', value: 'ANNEX_IV' },
  { label: 'Conformity Assessment', value: 'CONFORMITY_ASSESSMENT' },
  {
    label: 'EU Declaration of Conformity',
    value: 'EU_DECLARATION_OF_CONFORMITY',
  },
  { label: 'Fria', value: 'FRIA' },
  { label: 'Dpia', value: 'DPIA' },
  { label: 'Other', value: 'OTHER' },
];
